var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefreshIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 6.11279C15.5 6.55029 15.1562 6.86279 14.75 6.86279H11.25H10.25C9.8125 6.86279 9.5 6.55029 9.5 6.11279C9.5 5.70654 9.8125 5.36279 10.25 5.36279H11.25H12.9375L11.3125 3.73779C10.4062 2.86279 9.21875 2.36279 8 2.36279C5.71875 2.36279 3.75 3.76904 2.9375 5.73779C2.75 6.11279 2.3125 6.26904 1.9375 6.11279C1.5625 5.95654 1.375 5.51904 1.53125 5.14404C2.59375 2.64404 5.09375 0.862793 8 0.862793C9.625 0.862793 11.1875 1.51904 12.3438 2.67529L14 4.33154V2.61279V1.61279C14 1.20654 14.3125 0.862793 14.75 0.862793C15.1562 0.862793 15.5 1.20654 15.5 1.61279V6.11279ZM1.25 8.86279H4.75C5.15625 8.86279 5.5 9.20654 5.5 9.61279C5.5 10.0503 5.15625 10.3628 4.75 10.3628H3.03125L4.6875 12.019C5.5625 12.894 6.75 13.3628 8 13.3628C10.25 13.3628 12.2188 12.019 13.0312 10.0503C13.2188 9.64404 13.6562 9.48779 14.0312 9.64404C14.4062 9.80029 14.5938 10.2378 14.4375 10.644C13.3438 13.1128 10.875 14.8628 8 14.8628C6.34375 14.8628 4.78125 14.2378 3.625 13.0815L2 11.4253V13.1128C2 13.5503 1.65625 13.8628 1.25 13.8628C0.8125 13.8628 0.5 13.5503 0.5 13.1128V9.61279C0.5 9.20654 0.8125 8.86279 1.25 8.86279Z",
    fill: "#D8D8D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshIcon);
export default __webpack_public_path__ + "static/media/refresh_icon.469266958fdb7637975bb9f16395df07.svg";
export { ForwardRef as ReactComponent };